export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const animationStyle = {
  animationDuration: '1s',
  animationFillMode: 'both',
  animationIterationCount: 1,
  animationName: 'rubberBand'
};

export const setErrorClass = (rest: Record<string, any>) => rest.control.getFieldState(rest.name, rest.control._formState).invalid ? 'form-error' : '';
